import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import config from 'config';

const ProfileAccessContext = createContext();

export const useProfileAccess = () => {
  const context = useContext(ProfileAccessContext);
  if (!context) {
    throw new Error('useProfileAccess must be used within a ProfileAccessProvider');
  }
  return context;
};

export const ProfileAccessProvider = ({ children }) => {
  const [hasAccess, setHasAccess] = useState(true); // Default to true to avoid flash
  const [isLicenseOwner, setIsLicenseOwner] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [accessMessage, setAccessMessage] = useState('');

  // Check profile access on mount
  useEffect(() => {
    checkProfileAccess();
  }, []);

  const checkProfileAccess = async () => {
    try {
      // Skip on public pages (auth layout) or if no token
      if (!Cookies.get('loggedIn') || window.location.hash.startsWith('#/auth')) {
        setIsLoading(false);
        setHasAccess(true);
        return;
      }

      const response = await axios.get(`${config.apiUrl}/check-profile-access`);

      setHasAccess(response.data.hasAccess);
      setIsLicenseOwner(response.data.isLicenseOwner || false);
      setAccessMessage(response.data.message || '');
    } catch (error) {
      console.error('Error checking profile access:', error);
      // On error, default to allowing access to avoid blocking
      setHasAccess(true);
    } finally {
      setIsLoading(false);
    }
  };

  const refreshAccess = async () => {
    await checkProfileAccess();
  };

  const value = {
    hasAccess,
    isLicenseOwner,
    isLoading,
    accessMessage,
    refreshAccess
  };

  return (
    <ProfileAccessContext.Provider value={value}>
      {children}
    </ProfileAccessContext.Provider>
  );
};

export default ProfileAccessContext;
